import styled from 'styled-components';
import { SocialChannels } from './SocialChannels';

const Container = styled.footer`
	display: grid;
	grid-gap: 8px;
	padding: 96px 0 64px;
	margin-top: 48px;
	text-align: center;
	color: #fff;
	background-color: #174654;
`;

const Link = styled.a`
	${({ theme }) => theme.link};
`;

const Rights = styled.div`
	font-family: 'Montserrat';
`;

const Name = styled.div`
	${({ theme }) => theme.typography.heading6};
	margin-bottom: 8px;
`;

const contactData = {
	phone: '000 000 000',
	email: 'paulina@twoj-projekt.pl'
};

const socialChannels = {
	facebook: { label: 'Facebook', url: 'https://www.facebook.com/twojprojekt2020' },
	linkedin: { label: 'LinkedIn', url: 'https://www.linkedin.com/in/paulina-k-a759a41a0' }
};

export const Footer = () =>
	<Container>
		<SocialChannels items={socialChannels} />
		<Name>Twój Projekt</Name>
		<div>
			{/* T:&nbsp;<Link href={`tel:${contactData.phone}`}>{contactData.phone}</Link> &middot; */}
			Email:&nbsp;<Link href={`mailto:${contactData.email}`}>{contactData.email}</Link>
		</div>
		<div>
			<Link href="/polityka-prywatnosci">Polityka Prywatności</Link>
			&nbsp;&middot;&nbsp;
			<Link href="/regulamin-sprzedazy">Regulamin Sprzedaży</Link>
		</div>
		<Rights>©&nbsp;{new Date().getFullYear()}&nbsp;Wszelkie prawa zastrzeżone</Rights>
	</Container>